import React, { useState,useEffect } from 'react'
import { Box, Typography, Grid, Button, Table, TableContainer, TableHead, TableRow, Paper, TableBody, Modal, Menu, MenuItem, Snackbar, Alert } from '@mui/material'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import generateToken from '../../utils/generateToken'
import axios from 'axios'
import { styled } from '@mui/material/styles';
import AddressForm from './AddressForm'
import globalConfig from '../../utils/globalConfig'
import CallIcon from '@mui/icons-material/Call';
import globalStyles from '../../utils/globalStyles'
import legolasApi from '../../api/legolas'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

function Addresses(props) {
  const [addresses, setAddresses] = React.useState([])
  const [addressBilling, setAddressBilling] = React.useState(null)
  const [addressShipping, setAddressShipping] = React.useState(null)
  const [showAddressform, setShowAddressform] = React.useState(false)
  const [selectedAddress, setSelectedAddress] = React.useState(null)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [alertSuccess, setAlertSuccess] = React.useState('')
  const [openSuccess, setOpenSuccess] = React.useState(false)
  const [isB2BUser, setIsB2BUser] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  const findCountry = (id = 'SA') => {
    const countries = globalConfig.countryHash
    return countries[id]
  }

  React.useEffect(() => {
    const userId = props.userId
    const data = { 'customer_id': userId}
    const signedToken = generateToken(data)
    const payload = { "action": "addresses" }

    axios.post(`${legolasApi.url}/api/addresses`, payload, {
      headers: {
        'Authorization': `Bearer ${signedToken}`,
        'Content-Type': 'application/json'
      }
    }).then((res) => {
      const addressArr = res.data.data
      console.log('res.data', res.data)
      // if (addressArr && Array.isArray(addressArr)) {
      //   setDefaultParams(addressArr)
      //   setAddresses(addressArr)
      // }
     if (addressArr && Array.isArray(addressArr)) {
  setDefaultParams(addressArr);
  setAddresses(addressArr);

  const hasB2BAddress = addressArr.some(addr => addr.building_no && addr.building_no.trim() !== "");
  setIsB2BUser(hasB2BAddress);
}

    })
  },[])

  const setDefaultParams = (addresses) => {
    addresses.forEach((address) => {
      if (address.is_default_billing && addressBilling == null) {
        setAddressBilling(address)
        props.setDefBillingaddress && props.setDefBillingaddress(address)
      }
      if (address.is_default_shipping && addressShipping == null) {
        setAddressShipping(address)
      }
    })
  }

  const closeFormModal = () => {
    setShowAddressform(false)
  }

  const addNewAddress = () => {
    setShowAddressform(true);
    setSelectedAddress(null);
  }

  const editAddress = (address) => {
    console.log('edit address: ', address)
    setShowAddressform(true)
    setSelectedAddress(address)
  }

  const SetDefaultShipping = (id) => {
    const customerId = props.userId
    const payload = {
      'address_id': id,
      'is_default_shipping': true,
      'customer_id' : customerId
    }
    console.log('tokengenpayload',payload)
    const signedToken = generateToken(payload)
    const resourcePayload = { "action" : "update-address" }
    axios.post(`${legolasApi.url}/api/address/update`, resourcePayload, {
      headers: {
        'Authorization': `Bearer ${signedToken}`,
        'Content-Type': 'application/json'
      }
    }).then((res) => {
      handleAlertSuccess('Address has been updated successfully!');
      console.log('Address Updated: ')
      console.log(res)
      setTimeout(() => {
          window.location.reload();
      }, 3000)
    }).catch((error) => {
      console.log('error: ',error)
    })
  }

  const SetDefaultBilling = (id) => {
    const customerId = props.userId
    const payload = {
      'address_id': id,
      'is_default_billing': true,
      'customer_id' : customerId
    }
    console.log('tokengenpayload',payload)
    const signedToken = generateToken(payload)
    const resourcePayload = { "action" : "update-address" }
    axios.post(`${legolasApi.url}/api/address/update`, resourcePayload, {
      headers: {
        'Authorization': `Bearer ${signedToken}`,
        'Content-Type': 'application/json'
      }
    }).then((res) => {
      handleAlertSuccess('Address has been updated successfully!');
      console.log('Address Updated: ')
      console.log(res)
      setTimeout(() => {
          window.location.reload();
      }, 3000)
    }).catch((error) => {
      console.log('error: ',error)
    })
  }

  const DeleteAddress = (id) => {
    const payload = {
      'address_id': id
    }
    console.log('tokengenpayload',payload)
    const signedToken = generateToken(payload)
    const resourcePayload = { "action" : "delete-address" }
    axios.post(`${legolasApi.url}/api/address/delete`, resourcePayload, {
      headers: {
        'Authorization': `Bearer ${signedToken}`,
        'Content-Type': 'application/json'
      }
    }).then((res) => {
      handleAlertSuccess('Address has been deleted successfully!');
      console.log('Address Deleted: ');
      console.log(res);

      setTimeout(() => {
          window.location.reload();
      }, 3000);
    }).catch((error) => {
      console.log('error: ',error)
    });
  }

  const handleAlertSuccess = (message) => {
    setAlertSuccess(message)
    setOpenSuccess(true)
    setTimeout(() => {
      setAlertSuccess('')
      setOpenSuccess(false)
    }, 3000)
  }

  const closeSuccess = () => {
    setOpenSuccess(false)
  }

  const AddorEditAddress = (payload, type = 'add') => {
    switch(type) {
      case 'edit':
        setShowAddressform(false)
        const customerIdEdit = props.userId
        let editPayload = Object.assign(payload, { 'customer_id' : customerIdEdit })
        const signedTokenEdit = generateToken(editPayload)
        const resourcePayloadEdit = { "action" : "update-address" }
        axios.post(`${legolasApi.url}/api/address/update`, resourcePayloadEdit, {
          headers: {
            'Authorization': `Bearer ${signedTokenEdit}`,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          handleAlertSuccess('Address has been updated successfully!');
          console.log('Address Updated: ')
          console.log(res)
          setTimeout(() => {
            window.location.reload();
          }, 3000)
        })
        break

      default:
        setShowAddressform(false)
        const customerId = props.userId
        let finalPayload = Object.assign(payload, { 'customer_id' : customerId })
        console.log('final payload :')
        console.log(finalPayload)
        const signedToken = generateToken(finalPayload)
        const resourcePayload = { "action" : "add-address" }
        axios.post(`${legolasApi.url}/api/address/add`, resourcePayload, {
          headers: {
            'Authorization': `Bearer ${signedToken}`,
            'Content-Type': 'application/json'
          }
        }).then((res) => {
          handleAlertSuccess('Address has been added successfully!');
          console.log('Address added: ');
          console.log(res);
          setTimeout(() => {
            window.location.reload();
          }, 3000)
        })
        break
    }
  }
  
  return (
    <React.Fragment>
      <Box sx={{ width: '90%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
        <Typography variant='h6'>Addresses</Typography>
      </Box>
      <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccess} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeSuccess} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
          {alertSuccess}
        </Alert>
      </Snackbar>
      <Box>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={12}>
            <Box>
              <Typography variant='button' sx={{ fontSize: '1rem', fontWeight: 600, textTransform: 'capitalize' }}>Default Billing Address</Typography>
              {/* <Button onClick={() => setShowAddressform(true)}><Typography variant='button' sx={{ fontSize: '1rem', textTransform: 'capitalize' }}>Edit</Typography></Button> */}
            </Box>
            <Box>
              {addressBilling == null ?
                <Typography variant='subtitle1'>
                  This customer does not have default billing address
                </Typography> : 
                <Box>
                  <Typography variant='subtitle1'>{addressBilling.firstname} {addressBilling.lastname}</Typography>
                  <Typography varinat='subtitle1'>{addressBilling.street ? addressBilling.street : null}</Typography>
                  <Typography variant='subtitle1'>{addressBilling.city}, {findCountry(addressBilling.country_id)}</Typography>
                  {
                    addressBilling.phone &&
                    <Typography variant='subtitle1'><CallIcon sx={{ height: '20px', width: '20px', lineHeight: '20px', marginBottom: '-5px' }}/> : {addressBilling.phone}</Typography>
                  }
                </Box>
              }
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box>
              <Typography variant='button' sx={{ fontSize: '1rem', fontWeight: 600, textTransform: 'capitalize' }}>Default Shipping Address</Typography>
              {/* <Button onClick={() => setShowAddressform(true)}><Typography variant='button' sx={{ fontSize: '1rem', textTransform: 'capitalize' }}>Edit</Typography></Button> */}
            </Box>
            <Box>
              {addressShipping == null ?
                <Typography variant='subtitle1'>
                  This customer does not have default shipping address
                </Typography> : 
                <Box>
                  <Typography variant='subtitle1'>{addressShipping.firstname} {addressShipping.lastname}</Typography>
                  <Typography varinat='subtitle1'>{addressShipping.street ? addressShipping.street : null}</Typography>
                  <Typography variant='subtitle1'>{addressShipping.city}, {findCountry(addressShipping.country_id)}</Typography>
                  {
                    addressShipping.phone &&
                    <Typography variant='subtitle1'><CallIcon sx={{ height: '20px', width: '20px', lineHeight: '20px', marginBottom: '-5px' }}/> : {addressShipping.phone}</Typography>
                  }
                </Box>
              }
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ margin: '30px 10px 20px'}}>
        <Button 
          sx={{ float: 'right', backgroundColor: '#2b3f7a !important', color: '#fff', padding: '10px 20px', textTransform: 'capitalize', borderRadius: 0 }}
          onClick={() => addNewAddress()}
        >
          Add New Address
        </Button>
      </Box>
      {/* list of addresses */}
      <Box sx={{ margin:'0px 10px 20px 0px'}}>
      <TableContainer component={Paper} sx={{ paddingTop: '30px' }}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell align="center">First Name</StyledTableCell>
            <StyledTableCell align="center">Last Name</StyledTableCell>
            <StyledTableCell align="center">Street Address</StyledTableCell>
            <StyledTableCell align="center">City</StyledTableCell>
            <StyledTableCell align="center">Country</StyledTableCell>
            {/* <StyledTableCell align="center">State</StyledTableCell> */}
            <StyledTableCell align="center">Zip/Postal Code</StyledTableCell>
            <StyledTableCell align="center">Phone</StyledTableCell>
            <StyledTableCell align="center">Action</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {addresses.map((address) => (
            <StyledTableRow key={address.entity_id}>
              <StyledTableCell component="th" scope="row">
                {address.firstname}
              </StyledTableCell>
              <StyledTableCell align="center">{address.lastname}</StyledTableCell>
              <StyledTableCell align="center">{address.street}</StyledTableCell>
              <StyledTableCell align="center">{address.city}</StyledTableCell>
              <StyledTableCell align="center">{address.country_id}</StyledTableCell>
              {/* <StyledTableCell align="center">Null</StyledTableCell> */}
              <StyledTableCell align="center">{address.postcode}</StyledTableCell>
              <StyledTableCell align="center">{address.telephone}</StyledTableCell>
              <StyledTableCell align="center">
                <Box sx={{ display: 'block'}}>
                  <Box>
                    <Button onClick={() => editAddress(address)} sx={{ textTransform: 'capitalize', padding: 0 }}>Edit</Button>
                  </Box>
                  <Box>
                    <Button onClick={() => SetDefaultBilling(address.entity_id)} sx={{ textTransform: 'capitalize', padding: 0 }}>Set as default billing</Button>
                  </Box>
                  <Box>
                    <Button onClick={() => SetDefaultShipping(address.entity_id)} sx={{ textTransform: 'capitalize', padding: 0 }}>Set as default shipping</Button>
                  </Box>
                  <Box>
                    <Button onClick={() => DeleteAddress(address.entity_id)} sx={{ textTransform: 'capitalize', padding: 0 }}>Delete</Button>
                  </Box>
                </Box>
                {/* <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  <MenuItem onClick={() => editAddress(address)}>Edit</MenuItem>
                  <MenuItem onClick={() => SetDefaultBilling(address.entity_id)}>Set as default billing</MenuItem>
                  <MenuItem onClick={() => SetDefaultShipping(address.entity_id)}>Set as default shipping</MenuItem>
                  <MenuItem onClick={() => DeleteAddress(address.entity_id)}>Delete</MenuItem>
                </Menu> */}
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <Modal
        open={showAddressform}
        onClose={() => setShowAddressform(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AddressForm 
          address={selectedAddress} 
          isOrderAddress={false}
          isB2B={isB2BUser}      // pass flag from API result
          closeFormModal={closeFormModal} 
          AddorEditAddress={AddorEditAddress}
        />
      </Modal>
      </Box>
    </React.Fragment>
  )
}

export default Addresses